import { render, staticRenderFns } from "./PaperList.vue?vue&type=template&id=7b3ac89c"
import script from "./PaperList.vue?vue&type=script&lang=js"
export * from "./PaperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports